/* eslint camelcase: 0 */
import { MonitaroGatewayBase } from './base'
import { toHospitalProps } from './translator/hospital'
import { toQuery, toQueryProps } from './translator/query'
import { EmptyResponsePropsFactory } from '@/entities/Response'
import { IQueryProps } from '@/entities/Query'
import { FetchHospital, SelectableHospital, GetHospital, PutHospital } from '@/infrastructure/network/Monitaro/requests/hospital'

export default class Hospital extends MonitaroGatewayBase {
  async FetchHospital(query?: IQueryProps) {
    const response = await this.apiClient.request(new FetchHospital(toQuery(query)))
    return EmptyResponsePropsFactory({
      items: response.hospitals.map((prop) => toHospitalProps(prop)),
      query: toQueryProps(response.query)
    })
  }

  async SelectableHospital(query?: IQueryProps) {
    const response = await this.apiClient.request(new SelectableHospital(toQuery(query)))
    return EmptyResponsePropsFactory({
      items: response.hospitals.map((prop) => toHospitalProps(prop)),
      query: toQueryProps(response.query)
    })
  }

  async GetHospital(id: string) {
    const { hospital } = await this.apiClient.request(new GetHospital(id))
    return toHospitalProps(hospital)
  }

  async PutHospital(id: string) {
    const { hospital } = await this.apiClient.request(new PutHospital(id))
    return toHospitalProps(hospital)
  }
}
